import { render, staticRenderFns } from "./DwOrder.vue?vue&type=template&id=059304b9&scoped=true"
import script from "./DwOrder.vue?vue&type=script&lang=js"
export * from "./DwOrder.vue?vue&type=script&lang=js"
import style0 from "./DwOrder.vue?vue&type=style&index=0&id=059304b9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059304b9",
  null
  
)

export default component.exports